import { useEffect, useState } from "react";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup"
import { delete_comment, getCommentsReportByAttributeAndAttributeId, getStatus, post_comment } from "../../../services/Appointment";
import { useLocation, useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import { validateMin } from "../../../utils/validateMin";
import { CustomDateField } from "../../../components/CustomDateField";
import useConfirm from "../../../hook/useConfirm";
import axios from "axios";
import useAuth from "../../../hook/useAuth";
import moment from "moment";
import { getStatusColor } from "../../../utils/functionHelper";
import useDelete from "../../../hook/useDelete";
import AddComments from "./AddComments";
import { formatUSPhone } from "../../../utils/phoneFormatter";
import { categories } from "../../../utils/categoryType";


type CommentType = {
    id: number;
    attributeName: string;
    attributeId: string;
    notes: string;
    userName: string;
    createdDate: string;
};


export const EditPurchaseOrder = () => {
    const idNumber = useLocation();
    const { auth }: any = useAuth();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [locationId, setLocationId] = useState<number>(0);
    const [selectedCategory, setSelectedCategory] = useState<number>(1);
    const [selectedStatus, setSelectedStatus] = useState<number>(0);
    const [statusOptions, setStatusOptions] = useState<any[]>([]);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [purchaseOrderData, setPurchaseOrderData] = useState<any>(null);
    const [vendorId, setVendorId] = useState<number | null>(null);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [oldSelectedItems, setOldSelectedItems] = useState<any[]>([]);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(false);
    const [vendorDetails, setVendorDetails] = useState<any>({});
    const [saveCommentsValue, setSaveCommentsValue] = useState([]);
    const [vendorDataIsLoaded, setVendorDataIsLoaded] = useState<boolean>(true);
    const [isComment, setIsComment] = useState(0);
    const [comments, setComments] = useState<string>("");



    useEffect(() => {
        getStatus("PurchaseOrder")
            .then((data) => {
                setStatusOptions(() => data?.map((status: any) => {
                    return {
                        value: status?.statusID,
                        label: status?.statusValue
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        if (vendorId && vendorId > 0) {
            setVendorDataIsLoaded(false);
            axios
                .get(`${baseURL}vendors/GetVendorReport/${vendorId}`)
                .then((response) => {
                    setVendorDetails(response?.data);
                    setVendorDataIsLoaded(true);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [vendorId])

    useEffect(() => {
        if (vendorId && vendorId > 0) {
            getCommentsReportByAttributeAndAttributeId("Vendor", vendorId)
                .then(data => {
                    setSaveCommentsValue(data)
                })
                .catch(error => {
                    console.error(error);
                });

        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComment, vendorId]);




    useEffect(() => {
        if (idNumber?.state) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}purchaseOrderDetails/GePurchaseOrderDetailsByPurchaseOrder/${idNumber?.state}`)
                .then((response) => {
                    const data = response?.data?.map((item: any) => ({
                        ...item,
                        qtyOrdered: item.quantityOrdered,
                        qtyReceived: item.quantityReceived
                    }));
                    setPleaseWaitPopup(false);
                    setSelectedItems(data);
                    setOldSelectedItems(data);
                    setIsFirstTime(true);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });

            axios
                .get(`${baseURL}purchaseOrders/${idNumber?.state}`)
                .then((response) => {
                    setPurchaseOrderData(response?.data);
                    setLocationId(response?.data?.locationId);
                    setVendorId(response?.data?.vendorId);
                    setSelectedStatus(response?.data?.statusId);
                    setSelectedCategory(response?.data?.categoryType);
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
    }, [idNumber])

    const saveComments = () => {
        if (!comments?.trim()) {
            return;
        }
        setPleaseWaitPopup(true);

        post_comment(
            {
                attributeName: "Vendor",
                attributeId: vendorId,
                notes: comments,
                userId: auth?.id,
                createdDate: new Date().toLocaleString(),
            }, auth?.id)
            .then(() => {
                setComments("");
                setIsComment(isComment + 1);
                setPleaseWaitPopup(false);

            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error(error)
            });
    };

    const deleteTheComment = async (id: number) => {
        setDeleteData({
            id: id,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this comment?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();
                delete_comment(id, auth?.id)
                    .then(() => {
                        setSaveCommentsValue(saveCommentsValue.filter((item: any) => item.id !== id))
                        setPleaseWaitPopup(false);

                    })
                    .catch((error) => {
                        console.error(error)
                    });
            }
        });
        setDeletePopup(true);
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <div className="flex items-center justify-between py-2">
                        <h2 className={`text-lg font-semibold`}>Purchase Order - {idNumber?.state} - {categories.find((item: any) => item?.id === selectedCategory)?.label}</h2>
                        <div className="flex items-center gap-1.5">
                            <div>
                                <div>
                                    <select
                                        value={selectedStatus}
                                        onChange={(e) => {
                                            setSelectedStatus(Number(e.target.value))

                                        }}
                                        className="w-[120px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                                    >
                                        {statusOptions.map((status: any, index: number) => (
                                            <option key={index} value={status?.value}>
                                                {status?.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-between mt-2 p-2">
                        <div className="w-[65%] space-y-4">
                            <InventoryView
                                locationId={locationId}
                                selectedVendorId={vendorId}
                                selectedCategory={selectedCategory}
                                selectedItems={selectedItems}
                                oldSelectedItems={oldSelectedItems}
                                isFirstTime={isFirstTime}
                                setSelectedItems={setSelectedItems}

                            />

                            <SelectedInventoryView
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                            />

                            <ShipmentView
                                statusOptions={statusOptions}
                                selectedItems={selectedItems}
                                oldSelectedItems={oldSelectedItems}
                                setPleaseWaitPopup={setPleaseWaitPopup}
                                locationId={locationId}
                                selectedVendorId={vendorId}
                                selectedStatus={selectedStatus}
                                purchaseOrderData={purchaseOrderData}
                            />
                        </div>

                        <div className="w-[30%] space-y-4">
                            {
                                !vendorDataIsLoaded && (
                                    <div className="flex flex-col items-center rounded-lg bg-white px-6 py-8 shadow-sm">
                                        <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }

                            {
                                (vendorId !== null && vendorId > 0 && vendorDetails && vendorDataIsLoaded) && (
                                    <div className="w-full bg-white shadow-sm rounded-2xl p-6 border border-gray-100">

                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-6 border-b pb-2">
                                            <h2 className="text-sm font-semibold text-gray-800">
                                                Vendor Status
                                            </h2>
                                            {vendorDetails?.statusName && (() => {
                                                const color = getStatusColor(vendorDetails?.statusName);

                                                return (
                                                    <div className="flex items-end h-full">
                                                        <span
                                                            className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}
                                                        >
                                                            {vendorDetails?.statusName}
                                                        </span>
                                                    </div>
                                                );
                                            })()}
                                        </div>


                                        <div className="w-full space-y-2">

                                            {/* Contact Person 1 */}
                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Vendor
                                                </h3>
                                                <p className="text-sm font-semibold text-gray-800">
                                                    {vendorDetails?.vendorName}
                                                </p>

                                            </div>

                                            {/* Contacts Section */}


                                            {/* Contact Person 1 */}
                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Contact Person 1
                                                </h3>
                                                <p className="text-sm font-semibold text-gray-800">
                                                    {vendorDetails?.contactPerson1}
                                                </p>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    📞 {formatUSPhone(vendorDetails?.contactPerson1Phone)}
                                                </p>
                                            </div>

                                            {/* Contact Person 2 */}
                                            {vendorDetails?.contactPerson2 && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        Contact Person 2
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.contactPerson2}
                                                    </p>
                                                    <p className="text-sm text-gray-600 mt-1">
                                                        📞 {formatUSPhone(vendorDetails?.contactPerson2Phone)}
                                                    </p>
                                                </div>
                                            )}


                                            {vendorDetails?.email && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        Email
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.email}
                                                    </p>

                                                </div>
                                            )}

                                            {vendorDetails?.fax && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        FAX
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.fax}
                                                    </p>

                                                </div>
                                            )}

                                            {vendorDetails?.website && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        Website
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.website}
                                                    </p>

                                                </div>
                                            )}


                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Address
                                                </h3>
                                                <p className="text-sm text-gray-600">
                                                    {vendorDetails?.address1}, {vendorDetails?.address2}, {vendorDetails?.city}, {vendorDetails?.state}, {vendorDetails?.county}, {vendorDetails?.zipCode}, {vendorDetails?.country}
                                                </p>

                                            </div>

                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Delivery Time
                                                </h3>
                                                <p className="text-sm text-gray-800">
                                                    {vendorDetails?.deliveryTime}
                                                </p>

                                            </div>

                                        </div>
                                    </div>
                                )
                            }

                            {
                                (vendorId !== null && vendorId > 0) && (
                                    <div className="w-full px-2">

                                        <div className="mt-[16px]">
                                            <div className="flex items-center justify-between">
                                                <span className={`text-xs font-medium`}>Comments</span>

                                            </div>

                                            {
                                                saveCommentsValue && (
                                                    <div className="mt-[16px]">
                                                        {
                                                            saveCommentsValue.map((item: CommentType) => {
                                                                return (
                                                                    <AddComments
                                                                        id={item.id}
                                                                        userName={item.userName}
                                                                        createdDate={item.createdDate}
                                                                        notes={item.notes}
                                                                        deleteTheComment={(id) => deleteTheComment(id)}
                                                                    />
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                )
                                            }

                                            <div className="mt-[16px]">
                                                <textarea
                                                    className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                    rows={6}
                                                    value={comments}
                                                    onChange={(e) => setComments(e.target.value)}
                                                />
                                                <div className="mt-6">
                                                    <button
                                                        type="button"
                                                        onClick={() => saveComments()}
                                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                                    >
                                                        Save
                                                    </button>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}


type InventoryViewProps = {
    locationId: number;
    selectedVendorId: number | null;
    selectedCategory: number;
    selectedItems: any[];
    oldSelectedItems: any[];
    isFirstTime: boolean;
    setSelectedItems: (value: any[]) => void
}

const InventoryView = ({
    locationId,
    selectedVendorId,
    selectedCategory,
    selectedItems,
    oldSelectedItems,
    isFirstTime,
    setSelectedItems
}: InventoryViewProps) => {
    const [inventories, setInventories] = useState<any[]>([]);
    const [filterInventories, setFilterInventories] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedVendorId && selectedVendorId > 0 && isFirstTime) {
            if (locationId > 0) {
                if (selectedCategory === 1) {
                    setLoading(true);
                    fetch(`${baseURL}tireInventories/GetTireInventoriesReportByLocationIdAndByVendorId/${selectedVendorId},${locationId}`)
                        .then((res) => res.json())
                        .then((data) => {
                            const selectedItemNums = new Set(
                                selectedItems?.map((item: any) => item.itemNum)
                            );


                            const result = data?.map((item: any) => {
                                let isCheck = false;

                                if (selectedItemNums.has(item.sku)) {
                                    isCheck = true;
                                }

                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    isReorder: item?.quantityOnHand <= item?.reorderLevel,
                                    itemNum: item?.sku,
                                    costPer: item?.costPrice,
                                    inventroyType: "Tire",
                                    isCheck,
                                };
                            });

                            setSelectedItems(
                                selectedItems?.map((item: any) => ({
                                    ...item,
                                    oldItemQuntyReceived: item?.qtyReceived,
                                    modelName: data?.find(
                                        (inven: any) => inven.sku === item.itemNum
                                    )?.modelName,
                                    inventoryId: data?.find(
                                        (inven: any) => inven.sku === item.itemNum
                                    )?.inventoryId,
                                    inventroyType: "Tire",
                                    costPrice
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.costPrice,
                                    inHouse
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.inHouse,

                                    inventoryLocationId
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.locationId,
                                    price
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.price,
                                    quantityOnHand
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.quantityOnHand,
                                    rackCode
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.rackCode,
                                    reorderLevel
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.reorderLevel,
                                    reorderQuantity
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.reorderQuantity,
                                    salesTaxRate
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.salesTaxRate,
                                    shelf
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.shelf,
                                    tireProductId
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.tireProductId,
                                    waitingTimeUnit
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.waitingTimeUnit,
                                    waitingTimeUnitValue
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.waitingTimeUnitValue,

                                }))
                            );

                            setInventories(result);
                            setLoading(false);
                        })
                        .catch(error => {
                            setInventories([]);
                            setLoading(false);
                            console.error(error);
                        });
                }
                else {
                    setLoading(true);
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportByLocationIdAndByVendorId/${selectedVendorId},${locationId}`)
                        .then((res) => res.json())
                        .then((data) => {
                            const selectedItemNums = new Set(
                                selectedItems?.map((item: any) => item.itemNum)
                            );



                            const result = data?.map((item: any) => {
                                let isCheck = false;

                                if (selectedItemNums.has(item.sku)) {
                                    isCheck = true;

                                }

                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    isReorder: item?.quantityOnHand <= item?.reorderLevel,
                                    itemNum: item?.sku,
                                    costPer: item?.costPrice,
                                    inventroyType: "Wheel",
                                    isCheck,
                                };
                            });

                            setSelectedItems(
                                selectedItems?.map((item: any) => ({
                                    ...item,
                                    oldItemQuntyReceived: item?.qtyReceived,
                                    modelName: data?.find(
                                        (inven: any) => inven.sku === item.itemNum
                                    )?.modelName,
                                    inventoryId: data?.find(
                                        (inven: any) => inven.sku === item.itemNum
                                    )?.inventoryId,
                                    inventroyType: "Wheel",
                                    costPrice
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.costPrice,
                                    inHouse
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.inHouse,

                                    inventoryLocationId
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.locationId,
                                    price
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.price,
                                    quantityOnHand
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.quantityOnHand,
                                    rackCode
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.rackCode,
                                    reorderLevel
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.reorderLevel,
                                    reorderQuantity
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.reorderQuantity,
                                    salesTaxRate
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.salesTaxRate,
                                    shelf
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.shelf,
                                    sku
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.sku,
                                    wheelProductId
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.wheelProductId,
                                    waitingTimeUnit
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.waitingTimeUnit,
                                    waitingTimeUnitValue
                                        :
                                        data?.find(
                                            (inven: any) => inven.sku === item.itemNum
                                        )?.waitingTimeUnitValue,
                                }))
                            );

                            setInventories(result);
                            setLoading(false);
                        })
                        .catch(error => {
                            setInventories([]);
                            setLoading(false);
                            console.error(error);
                        });
                }
            }

        }
        else {
            setInventories([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId, selectedVendorId, selectedCategory, isFirstTime])

    useEffect(() => {
        const search = searchValue.toLowerCase()?.trim()
        if (search === "") {
            setFilterInventories(inventories)
        }
        else {
            setFilterInventories(() =>
                inventories.filter((item: any) => item?.sku?.toLowerCase()?.includes(search) || item?.modelName?.toLowerCase()?.includes(search) || item?.brandName?.toLowerCase()?.includes(search))
            )
        }
    }, [inventories, searchValue])


    const handleItemOnChecked = (id: number) => {
        const data = filterInventories.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    isCheck: !item.isCheck,
                };
            }

            return item;
        });
        setFilterInventories(data);

        const selectedData = data
            .filter((item: any) => item.isCheck)
            .map((item: any) => {
                if (
                    oldSelectedItems?.find(
                        (oldItem: any) => oldItem?.itemNum === item?.itemNum
                    ) !== undefined
                ) {
                    const oldItem = oldSelectedItems?.find(
                        (oldItem: any) => oldItem?.itemNum === item?.itemNum
                    );
                    return {
                        ...oldItem,
                        oldItemQuntyReceived: oldItem?.qtyReceived,
                        modelName: item?.modelName
                    }
                } else {
                    return {
                        ...item,
                        inventoryLocationId: item?.locationId,
                        itemNum: item?.sku,
                        qtyOrdered: 0,
                        qtyReceived: 0,
                        oldItemQuntyReceived: 0
                    }
                }
            });

        setSelectedItems(selectedData);
    };


    return (
        <section className="border border-gray-200 rounded-xl bg-white shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center px-4 py-3 border-b bg-gradient-to-r from-gray-50 to-white rounded-t-xl">
                <span className="font-semibold text-lg text-gray-800">Vendor Items</span>

                <input
                    className="bg-gray-100 focus:bg-white border border-gray-200 focus:border-primary px-3 py-1.5 rounded-full text-sm text-gray-700 placeholder:text-gray-400 outline-none transition-all duration-200 shadow-sm focus:shadow"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>

            {/* Table Container */}
            <div className="h-64 overflow-y-auto mt-2">
                <table className="w-full text-sm">
                    {/* Header */}
                    <thead className="sticky top-0 z-10 bg-gray-100 shadow-sm whitespace-nowrap">
                        <tr>
                            <th className="px-4 py-3 text-left font-semibold text-gray-700"></th>
                            {[
                                "Item No.",
                                "Model Name",
                                "Brand Name",
                                "In Stock",
                                "Reorder Level",
                                "Reorder Quantity",
                                "PricePer",
                            ].map((item, index) => (
                                <th
                                    key={index}
                                    className="px-4 py-3 text-left font-semibold text-gray-700"
                                >
                                    {item}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Body */}
                    <tbody className="divide-y">
                        {filterInventories?.map((item, index) => (
                            <tr
                                key={index}
                                className={`transition-colors duration-150  ${item?.isReorder ? "bg-red-300 border-l-4 border-red-500 hover:bg-red-300" : "hover:bg-gray-50"} `}
                                onClick={() => handleItemOnChecked(item.id)}
                            >
                                <td className="px-4 py-3">
                                    <input
                                        type="checkbox"
                                        checked={item?.isCheck}
                                        className="w-4 h-4 accent-primary cursor-pointer"
                                        onChange={() => handleItemOnChecked(item.id)}
                                    />
                                </td>

                                <td className="px-4 py-3 font-medium text-gray-800">
                                    {item?.itemNum}
                                </td>
                                <td className="px-4 py-3 text-gray-700">{item?.modelName}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.brandName}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.quantityOnHand}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.reorderLevel}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.reorderQuantity}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.costPer}</td>
                            </tr>
                        ))}

                        {loading && (
                            <tr>
                                <td colSpan={10} className="text-center py-6 text-gray-500">
                                    Loading...
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>

    );
};

type SelectedInventoryViewProps = {
    selectedItems: any[];
    setSelectedItems: (value: any[]) => void
}

const SelectedInventoryView = ({
    selectedItems,
    setSelectedItems
}: SelectedInventoryViewProps) => {
    const [filterSelectedItems, setFilterSelectedItems] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");

    useEffect(() => {
        const search = searchValue.toLowerCase()?.trim()
        if (search === "") {
            setFilterSelectedItems(selectedItems)
        }
        else {
            setFilterSelectedItems(() =>
                selectedItems.filter((item: any) => item?.sku?.toLowerCase()?.includes(search) || item?.modelName?.toLowerCase()?.includes(search))
            )
        }
    }, [selectedItems, searchValue])


    return (
        <section className="border border-gray-200 rounded-xl bg-white shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center px-4 py-3 border-b bg-gradient-to-r from-gray-50 to-white rounded-t-xl">
                <span className="font-semibold text-lg text-gray-800">Selected Items</span>

                <input
                    className="bg-gray-100 focus:bg-white border border-gray-200 focus:border-primary px-3 py-1.5 rounded-full text-sm text-gray-700 placeholder:text-gray-400 outline-none transition-all duration-200 shadow-sm focus:shadow"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>

            {/* Table Container */}
            <div className="h-64 overflow-y-auto mt-2">
                <table className="w-full text-sm">
                    {/* Header */}
                    <thead className="sticky top-0 z-10 bg-gray-100 shadow-sm whitespace-nowrap">
                        <tr>
                            {[
                                "#",
                                "Item No.",
                                "Model Name",
                                "Quantity Ordered",
                                "Cost",
                                "QtyReceived"
                            ].map((item, index) => (
                                <th
                                    key={index}
                                    className="px-4 py-3 text-left font-semibold text-gray-700"
                                >
                                    {item}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Body */}
                    <tbody className="divide-y">
                        {filterSelectedItems?.map((item, index) => (
                            <tr
                                key={index}
                                className={`transition-colors duration-150 hover:bg-gray-50`}
                            //onClick={() => handleItemOnChecked(item.id)}
                            >
                                <td className="px-4 py-3 font-medium text-gray-800">
                                    {index + 1}
                                </td>
                                <td className="px-4 py-3 font-medium text-gray-800">
                                    {item.itemNum}
                                </td>
                                <td className="px-4 py-3 font-medium text-gray-800">{item.modelName}</td>
                                <td className="px-4 py-3  font-medium text-gray-800">
                                    <input
                                        className="outline-none rounded-md p-2 border border-gray-400 bg-gray-50 focus:bg-white focus:border-primary"
                                        min={0}
                                        type="number"
                                        value={item.qtyOrdered}
                                        onChange={(e) => {
                                            let qnty = validateMin(e.target.value, 0)
                                            setSelectedItems(
                                                selectedItems.map((_: any, i: number) =>
                                                    i === index ? { ..._, qtyOrdered: qnty } : _
                                                )
                                            );
                                        }}
                                    />
                                </td>
                                <td className="px-4 py-3  font-medium text-gray-800">{item.costPer}</td>
                                <td className="px-4 py-3  font-medium text-gray-800">
                                    <input
                                        className="outline-none rounded-md p-2 border border-gray-400 bg-gray-50 focus:bg-white focus:border-primary"
                                        min={0}
                                        type="number"
                                        value={item.qtyReceived}
                                        onChange={(e) => {
                                            let qnty = validateMin(e.target.value, 0)

                                            setSelectedItems(
                                                selectedItems.map((_: any, i: number) =>
                                                    i === index ? { ..._, qtyReceived: qnty } : _
                                                )
                                            );
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}


                    </tbody>
                </table>
            </div>
        </section>
    )
}

type ShipmentViewProps = {
    statusOptions: any[]
    selectedItems: any[]
    oldSelectedItems: any[]
    setPleaseWaitPopup: (value: boolean) => void
    selectedVendorId: null | number
    selectedStatus: number
    locationId: number
    purchaseOrderData: any
}
const ShipmentView = ({ statusOptions, selectedItems, oldSelectedItems, setPleaseWaitPopup, selectedVendorId, selectedStatus, locationId, purchaseOrderData }: ShipmentViewProps) => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [expanded, setExpanded] = useState<boolean>(false);
    const [shipVia, setShipVia] = useState<string>("");
    const [shipToStreet, setShipToStreet] = useState<string>("");
    const [shipToStreet2, setShipToStreet2] = useState<string>("");
    const [shipToCity, setShipToCity] = useState<string>("");
    const [shipToState, setShipToState] = useState<string>("");
    const [shipToCountry, setShipToCountry] = useState<string>("");
    const [shipToZip, setShipToZip] = useState<string>("");
    const [billToStreet, setBillToStreet] = useState<string>("");
    const [billToStreet2, setBillToStreet2] = useState<string>("");
    const [billToCity, setBillToCity] = useState<string>("");
    const [billToState, setBillToState] = useState<string>("");
    const [billToCountry, setBillToCountry] = useState<string>("");
    const [billToZip, setBillToZip] = useState<string>("");
    const [reference, setReference] = useState<string>("");
    const [dueDate, setDueDate] = useState<string>("");
    const [instructions, setInstructions] = useState<string>("");
    const [orderReason, setOrderReason] = useState<string>("");
    const [isCopiedShippingAddress, setIsCopiedShippingAddress] = useState<boolean>(false);

    useEffect(() => {
        if (purchaseOrderData) {
            setShipVia(purchaseOrderData?.shipVia);
            setShipToStreet(purchaseOrderData?.shipToStreet);
            setShipToStreet2(purchaseOrderData?.shipToStreet2);
            setShipToCity(purchaseOrderData?.shipToCity);
            setShipToState(purchaseOrderData?.shipToState);
            setShipToCountry(purchaseOrderData?.shipToCountry);
            setShipToZip(purchaseOrderData?.shipToZip);
            setBillToStreet(purchaseOrderData?.billToStreet);
            setBillToStreet2(purchaseOrderData?.billToStreet2);
            setBillToCity(purchaseOrderData?.billToCity);
            setBillToState(purchaseOrderData?.billToState);
            setBillToCountry(purchaseOrderData?.billToCountry);
            setBillToZip(purchaseOrderData?.billToZip);
            setDueDate(moment(new Date(purchaseOrderData?.dueDate)).format("YYYY-MM-DD"))
            setReference(purchaseOrderData?.reference)
            setInstructions(purchaseOrderData?.instructions)
            setOrderReason(purchaseOrderData?.orderReason)
            setIsCopiedShippingAddress(false);
        }
    }, [purchaseOrderData])

    useEffect(() => {
        if (isCopiedShippingAddress) {
            setBillToStreet(shipToStreet);
            setBillToStreet2(shipToStreet2);
            setBillToCity(shipToCity);
            setBillToState(shipToState);
            setBillToCountry(shipToCountry);
            setBillToZip(shipToZip);
        }
        else {
            setBillToStreet("");
            setBillToStreet2("");
            setBillToCity("");
            setBillToState("");
            setBillToCountry("");
            setBillToZip("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCopiedShippingAddress])

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (selectedItems?.length > 0) {
            let totalQuntyOrdered = 0;
            let totalQuntyReceived = 0;

            selectedItems?.forEach((item: any) => {
                totalQuntyOrdered += item.qtyOrdered
                totalQuntyReceived += item.qtyReceived
            });
            if (!expanded) {
                if (
                    shipVia !== "" &&
                    shipToStreet !== "" &&
                    shipToCity !== "" &&
                    shipToState !== "" &&
                    shipToCountry !== "" &&
                    shipToZip !== "" &&
                    billToStreet !== "" &&
                    billToCity !== "" &&
                    billToState !== "" &&
                    billToCountry !== "" &&
                    billToZip !== "" &&
                    dueDate !== ""
                ) {

                    if (totalQuntyOrdered < totalQuntyReceived) {
                        setConfirmPopup(true);
                        setConfirmData({
                            title: "Are you sure you want to update this purchase order with quantity received more than quantity ordered?",
                            confirmBtn: "Yes",
                            isCancelBtn: true,
                            isConfirm: (callback: any) => {
                                saveData(callback)
                            }
                        })
                    }
                    else {
                        setConfirmPopup(true);
                        setConfirmData({
                            title: "Are you sure you want to update the purchase order?",
                            confirmBtn: "Yes",
                            isCancelBtn: true,
                            isConfirm: (callback: any) => {
                                saveData(callback)
                            }
                        })
                    }


                }
                else {
                    setConfirmPopup(true);
                    setConfirmData({
                        title: "Please fill all the required fields",
                        confirmBtn: "Yes",
                        isCancelBtn: true,
                        isConfirm: (callback: any) => {
                            setExpanded(true);
                            callback()
                        }
                    })

                }
            }
            else {
                if (totalQuntyOrdered < totalQuntyReceived) {
                    setConfirmPopup(true);
                    setConfirmData({
                        title: "Are you sure to you want update this purchase order with quantity received more than quantity ordered?",
                        confirmBtn: "Yes",
                        isCancelBtn: true,
                        isConfirm: (callback: any) => {
                            saveData(callback)
                        }
                    })
                }
                else {
                    setConfirmPopup(true);
                    setConfirmData({
                        title: "Are you sure you want to update the purchase order?",
                        confirmBtn: "Yes",
                        isCancelBtn: true,
                        isConfirm: (callback: any) => {
                            saveData(callback)
                        }
                    })
                }
            }
        }
        else {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please add at least one item to update purchase order.",
                confirmBtn: "Yes",
                isCancelBtn: true,
                isConfirm: (callback: any) => {
                    setExpanded(true);
                    callback()
                }
            })
        }
    }

    const saveData = async (callback: any) => {
        setPleaseWaitPopup(true)
        let totalCost = 0;
        let totalCostReceived = 0;
        let isPartiallyReceived = false;
        let totalQuntyOrdered = 0;
        let totalQuntyReceived = 0;
        selectedItems?.forEach((item: any) => {
            totalCost += item.costPer * item.qtyOrdered;
            totalCostReceived += item.costPer * item.qtyReceived;
            totalQuntyOrdered += item.qtyOrdered
            totalQuntyReceived += item.qtyReceived
            if (!isPartiallyReceived) {
                isPartiallyReceived = item.qtyReceived > 0 && item.qtyReceived < item.qtyOrdered ? true : false
            }
        });


        await axios.put(
            `${baseURL}purchaseOrders?userId=${auth?.id}`,
            JSON.stringify({
                ...purchaseOrderData,
                reference,
                totalCost,
                totalCostReceived,
                dueDate,
                shipVia,
                shipToStreet,
                shipToStreet2,
                shipToCity,
                shipToState,
                shipToCountry,
                shipToZip,
                billToStreet,
                billToStreet2,
                billToCity,
                billToState,
                billToCountry,
                billToZip,
                instructions,
                statusId: isPartiallyReceived ? statusOptions?.find((item: any) => item?.label === "Partially Received")?.value : totalQuntyOrdered === totalQuntyReceived || totalQuntyOrdered < totalQuntyReceived ? statusOptions?.find((item: any) => item?.label === "Received")?.value : selectedStatus,
                billableDepartment: "",
                orderingMode: "",
                fullyAuthorized: true,
                cancelDate: "",
                totalCharges: 0,
                fullyPaid: true,
                orderReason,
                distributor: "",
                updatedAt: new Date().toLocaleString(),
                updatedBy: auth?.givenname
            }),
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: false,
            }
        )
            .then((res) => {
                const handleDeletedItems = async () => {
                    try {
                        if (!oldSelectedItems?.length) {
                            addAndEditList(callback, isPartiallyReceived, totalQuntyOrdered, totalQuntyReceived);
                            return;
                        }

                        // create set of current selected ids for fast lookup
                        const selectedIds = new Set(
                            selectedItems?.map((item: any) => item.id)
                        );

                        // filter items that need deletion
                        const itemsToDelete = oldSelectedItems.filter(
                            (order: any) => !selectedIds.has(order.id)
                        );

                        // if nothing to delete → continue
                        if (!itemsToDelete.length) {
                            addAndEditList(callback, isPartiallyReceived, totalQuntyOrdered, totalQuntyReceived);
                            return;
                        }

                        // run delete APIs in parallel
                        await Promise.all(
                            itemsToDelete.map(async (order: any) =>
                                await axios.delete(`${baseURL}/purchaseOrderDetails?id=${order?.id}&userId=${auth?.id}`)
                            )
                        );

                        addAndEditList(callback, isPartiallyReceived, totalQuntyOrdered, totalQuntyReceived);
                    } catch (error) {
                        console.error(error);
                        callback();
                    }
                };
                handleDeletedItems();
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });



    }


    const addAndEditList = async (callback: any, isPartiallyReceived: boolean, totalQuntyOrdered: number, totalQuntyReceived: number) => {
        try {

            // 🔹 create map for fast lookup by itemNum (or id if that's correct key)
            const oldItemsMap = new Map(
                oldSelectedItems?.map((order: any) => [order.itemNum, order])
            );

            const requests = selectedItems.map(async (item: any, index: number) => {
                const existing = oldItemsMap.get(item.itemNum);

                const payload = {
                    ...(existing && { id: existing.id }),
                    locationId,
                    purchaseOrderId: purchaseOrderData?.purchaseOrderId,
                    itemNum: item.itemNum,
                    lineNumber: index + 1,
                    quantityOrdered: item.qtyOrdered,
                    costPer: item.costPer,
                    quantityReceived: item.qtyReceived,
                    vendorPartNumber: "",
                    casePack: 0,
                    currentBatchQuantity: 0,
                    quantityDamaged: 0,
                    reason: "",
                    numberPerCase: 0,
                    overrideCommission: true,
                    quantityOutofDate: 0,
                };

                return existing
                    ? axios.put(`${baseURL}purchaseOrderDetails?userId=${auth?.id}`, JSON.stringify(payload),
                        {
                            headers: { "Content-Type": "application/json" },
                            withCredentials: false,
                        })
                    : await axios.post(
                        `${baseURL}purchaseOrderDetails?userId=${auth?.id}`, JSON.stringify(payload),
                        {
                            headers: { "Content-Type": "application/json" },
                            withCredentials: false,
                        }
                    );
            });

            await Promise.all(requests);
            if (statusOptions?.find((item: any) => item?.value === selectedStatus)?.label === "Received" || isPartiallyReceived || (!isPartiallyReceived && (totalQuntyOrdered === totalQuntyReceived || totalQuntyOrdered < totalQuntyReceived))) {
                const inventoryRequest = selectedItems.map(async (item: any) => {
                    if (item?.inventroyType === "Tire") {
                        return await axios
                            .put(
                                `${baseURL}tireInventories?userId=${auth?.id}`,
                                JSON.stringify({
                                    inventoryId: item?.inventoryId,
                                    tireProductId: item?.tireProductId,
                                    locationId: item?.inventoryLocationId,
                                    rackCode: item?.rackCode,
                                    shelf: item?.shelf,
                                    quantityOnHand: item?.qtyReceived === item?.oldItemQuntyReceived ? item?.quantityOnHand :
                                        item?.qtyReceived < item?.oldItemQuntyReceived ? (item?.quantityOnHand - item?.oldItemQuntyReceived) + item?.qtyReceived :
                                            (item?.quantityOnHand - item?.oldItemQuntyReceived) + item?.qtyReceived,
                                    reorderLevel: item?.reorderLevel,
                                    reorderQuantity: item?.reorderQuantity,
                                    costPrice: item?.costPrice,
                                    inHouse: item?.inHouse,
                                    waitingTimeValue: item?.waitingTimeValue,
                                    waitingTimeUnit: item?.waitingTimeUnit,
                                    salesTaxRate: item?.salesTaxRate,
                                }),
                                {
                                    headers: { "Content-Type": "application/json" },
                                    withCredentials: false,
                                }
                            )
                    }
                    else {
                        return await axios
                            .put(
                                `${baseURL}wheelInventories?userId=${auth?.id}`,
                                JSON.stringify({
                                    inventoryId: item?.inventoryId,
                                    wheelProductId: item?.wheelProductId,
                                    locationId: item?.locationId,
                                    rackCode: item?.rackCode,
                                    shelf: item?.shelf,
                                    quantityOnHand: item?.qtyReceived === item?.oldItemQuntyReceived ? item?.quantityOnHand :
                                        item?.qtyReceived < item?.oldItemQuntyReceived ? (item?.quantityOnHand - item?.oldItemQuntyReceived) + item?.qtyReceived :
                                            (item?.quantityOnHand - item?.oldItemQuntyReceived) + item?.qtyReceived,
                                    reorderLevel: item?.reorderLevel,
                                    reorderQuantity: item?.reorderQuantity,
                                    costPrice: item?.costPrice,
                                    inHouse: item?.inHouse,
                                    waitingTimeValue: item?.waitingTimeValue,
                                    waitingTimeUnit: item?.waitingTimeUnit,
                                    salesTaxRate: item?.salesTaxRate,
                                }),
                                {
                                    headers: { "Content-Type": "application/json" },
                                    withCredentials: false,
                                }
                            )
                    }




                })
                await Promise.all(inventoryRequest);
            }
            callback();
            setPleaseWaitPopup(false);
            navigate(-1);

        } catch (error) {
            console.error(error);
            callback();
        }
    };


    return (
        <section className="py-2 bg-white border border-gray-200 rounded-xl shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center px-4 py-3">
                <h5
                    className="flex items-center gap-2 cursor-pointer select-none"
                    onClick={() => setExpanded(!expanded)}
                >
                    <span className="material-symbols-outlined text-[26px] text-gray-600 transition-transform duration-200">
                        {expanded ? "keyboard_arrow_down" : "keyboard_arrow_right"}
                    </span>
                    <span className="font-semibold text-lg text-gray-800">Ship</span>
                </h5>
            </div>

            <div className="px-4">
                <hr className="w-full h-[1px] bg-gray-200" />
            </div>

            <form
                onSubmit={handleSubmit}
                className="w-full rounded-md px-5 py-4 relative">
                {expanded ? (
                    <div className="my-2 text-center">
                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Ship Via
                                </label>
                                <input
                                    name="shipVia"
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipVia}
                                    onChange={(e) => setShipVia(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm flex justify-center items-center">
                                <button
                                    type="button"
                                    className="font-semibold flex items-center gap-2 text-gray-600 hover:text-secondary transition"

                                >
                                    <span>Copy Shipping Address</span>
                                    <input type="checkbox" className="accent-secondary"
                                        checked={isCopiedShippingAddress}
                                        onChange={(e) => setIsCopiedShippingAddress(e.target.checked)}
                                    />
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping Street
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToStreet}
                                    onChange={(e) => setShipToStreet(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing Street
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToStreet}
                                    onChange={(e) => setBillToStreet(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping Street 2
                                </label>
                                <input
                                    type="text"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToStreet2}
                                    onChange={(e) => setShipToStreet2(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing Street 2
                                </label>
                                <input
                                    type="text"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToStreet2}
                                    onChange={(e) => setBillToStreet2(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping City
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToCity}
                                    onChange={(e) => setShipToCity(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing City
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToCity}
                                    onChange={(e) => setBillToCity(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping State
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToState}
                                    onChange={(e) => setShipToState(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing State
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToState}
                                    onChange={(e) => setBillToState(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping Country
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToCountry}
                                    onChange={(e) => setShipToCountry(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing Country
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToCountry}
                                    onChange={(e) => setBillToCountry(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shiping ZipCode
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToZip}
                                    onChange={(e) => setShipToZip(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing ZipCode
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToZip}
                                    onChange={(e) => setBillToZip(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Reference #
                                </label>
                                <input
                                    name="reference"
                                    type="text"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={reference}
                                    onChange={(e) => setReference(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Due Date
                                </label>
                                <CustomDateField
                                    value={dueDate}
                                    onChange={(value) => { setDueDate(value) }}
                                    minDate={new Date().toISOString().split("T")[0]}
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    required={true}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Instructions
                                </label>
                                <textarea
                                    name="instructions"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={instructions}
                                    onChange={(e) => setInstructions(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Order Reason
                                </label>
                                <textarea
                                    name="orderReason"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={orderReason}
                                    onChange={(e) => setOrderReason(e.target.value)}
                                />
                            </div>


                        </div>
                    </div>
                ) : null}

                {/* Buttons */}
                <div className="flex max-sm:flex-col gap-4 mt-6">
                    <button
                        type="submit"
                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                    >
                        Save
                    </button>

                    <button
                        type="button"
                        //onClick={() => navigate(-1)}
                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </section>

    )
}